<template>
  <!-- 公告查看 -->
  <div class="announcementview">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="ft20 D1D1D1">公告查看</span>
      </div>
      <div class="select_box flex">
        <div class="select_box_input">
           <!-- 公告类型 -->
        <el-select
          size="small"
          v-model="selectValue.typeValue"
          clearable
          placeholder="公告类型">
          <el-option
            v-for="item in noticeType"
            :key="item.dictCode"
            :label="item.dictValue"
            :value="item.dictCode">
          </el-option>
        </el-select>
        <!-- 有效期状态 -->
        <el-select
          size="small"
          v-model="selectValue.noticeStateValue"
          clearable
          placeholder="有效期状态"
        >
          <el-option
            v-for="item in noticeState"
            :key="item.dictCode"
            :label="item.dictValue"
            :value="item.dictCode"
          >
          </el-option>
        </el-select>
        <!--消息状态 -->
        <el-select
          size="small"
          v-model="selectValue.msgStateValue"
          clearable
          placeholder="消息状态"
        >
          <el-option
            v-for="item in msgState"
            :key="item.dictCode"
            :label="item.dictValue"
            :value="item.dictCode"
          >
          </el-option>
        </el-select>
          <el-date-picker
            size="small"
            v-model="selectValue.dateTimeValue"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </div>
        <div class="select_box_btn">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="queryClick"
            >查询</el-button
          >
          <el-button
            size="small"
            type="primary"
            plain
            icon="el-icon-refresh-right"
            @click="resetClick"
            >重置</el-button>
        </div>
      </div>
      <div class="text item announcementview_content">
        <el-table
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          :header-cell-style="{ textAlign: 'center',fontSize:'13px',color:'#787878',background:'#F5F5F5'}"
          :cell-style="{textAlign:'center',fontSize:'14px',color:'#1D1D1D'}"
          :row-class-name="tableRowClassName"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column prop="title" label="公告名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="typeName" label="公告类型"> </el-table-column>
          <el-table-column prop="createDate" label="发布日期">
          </el-table-column>
          <el-table-column
            prop="startTime"
            :formatter="formatterStartDate"
            label="开始时间"
          >
          </el-table-column>
          <el-table-column
            prop="endTime"
            :formatter="formatterEndDate"
            label="结束时间"
          >
          </el-table-column>
          <el-table-column prop="noticeStateName" label="有效期状态">
          </el-table-column>
          <el-table-column prop="msgStateName" label="消息状态">
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pageschange">
        <el-pagination
          background
          layout="total,prev, pager, next"
          :total="total"
          :page-size="page.pageSize"
          :current-page="page.pageNum"
          prev-text="上一页"
          next-text="下一页"
          @current-change="queryClick()"
          :hide-on-single-page="hiddenPage"
        >
          <!-- @next-click="nextClick"
          @prev-click="prevClick" -->
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
/**
 *   @Author : 李阳
 *   @Date : 2021/3/30
 *   @Version : 1.0.0
 *   @Last Modified by : 李阳
 *   @Last Modified time : 2021/3/30
 *   @description 公告查看
 **/
import { HomenoticeList, mdmdictdata } from "@/api/api";
import { Storage } from "@/utils/storage";
export default {
  name: "announcementview",
  data() {
    return {
      /************************下拉类型参数************************** */
      noticeType: [], // 1.公告类型
      noticeState: [], // 2.有效期状态
      msgState: [], // 3.消息状态
      /************************请求参数************************** */
      tableData: [], // 1.list分页展示接口接受参数
      selectValue: {
        // 2.select 下拉选择参数双向数据绑定接收对象
        typeValue: "",
        noticeStateValue: "",
        msgStateValue: "",
        dateTimeValue: [],
      },
      page: {
        // 3.请求分页参数
        pageSize: 10, //每页展示的条数
        pageNum: 1, //第几页
      },
      total: 0, //总的条数
      hiddenPage: false, //分页器显示与隐藏参数
      loading:true
    };
  },
  computed: {
    /**
     *@description       接口请求
     *@param  { String } type        公告类型
     *@param  { String } noticeState 有效期状态
     *@param  { String } msgState    消息状态
     *@param  { String } startTime   开始时间
     *@param  { String } endTime     结束时间
     *@param  { String } pageSize    请求的每页条数
     *@param  { String } pageNum     请求的页数
     *@return { Object } 页面接口请求对象
     */
    queryData() {
      return {
        type: this.selectValue.typeValue || "",
        noticeState: this.selectValue.noticeStateValue || "",
        msgState: this.selectValue.msgStateValue || "",
        startTime: this.selectValue.dateTimeValue[0] || "",
        endTime: this.selectValue.dateTimeValue[1] || "",
        pageSize: this.page.pageSize || "",
        pageNum: this.page.pageNum || "",
      };
    },
  },
  watch: {
    /**
     * @description    分页条数监听函数
     * @param { Number }  newVal 表示 total 的改变的值
     */
    total(newVal, oldVal) {
      if (newVal == 0) {
        this.hiddenPage = true;
      } else {
        this.hiddenPage = false;
      }
    },
  },
  methods: {
    // 隔行显示高亮
    tableRowClassName({row, rowIndex}) {
      if (!(rowIndex%2 ==0)) {
        return 'success-row';
      }
      return '';
    },
    /*********************接口请求方法*********************/
    /**
     * @description    公告接口请求函数
     */
    getNoticeList(params) {
      HomenoticeList(params).then((res) => {
        this.total = res.result.count;
        this.tableData = res.result.data;
        this.loading = false
      });
    },
    /**
     * @description    下拉类型字典接口请求函数
     */
    getDictionariesData() {
      let type = {
        dictTypeCode: "notice_type",
      };
      let notice_state = {
        dictTypeCode: "notice_state",
      };
      let msg_state = {
        dictTypeCode: "notice_msg_state",
      };
      mdmdictdata(type).then((res) => {
        this.noticeType = res.result;
      });
      mdmdictdata(notice_state).then((res) => {
        this.noticeState = res.result;
      });
      mdmdictdata(msg_state).then((res) => {
        this.msgState = res.result;
      });
    },
    /**********************按钮事件***********************/
    /**
     * @description  查询按钮
     */
    queryClick() {
      this.getNoticeList(this.queryData);
    },
    /**
     * @description  重置按钮
     */
    resetClick() {
      // 首先清空选项
      this.selectValue = {
        typeValue: "",
        noticeStateValue: "",
        msgStateValue: "",
        dateTimeValue: [],
      };
      // 再次请求接口
      this.getNoticeList(this.queryData);
    },
    /**
     * @description  单元格查看按钮
     * @param { Object } row 点击查看所在的行
     * @param { String } id  查看跳转的查询参数
     */
    handleClick(row) {
      this.$router.push({
          path:'/home/announcementdet',
          query:{
            id:row.id
          }
        });
    },
    /*********************table显示数据格式化方法************************/
    /**
     * @description  日期过滤函数
     * @function  formatterStartDate 开始日期过滤
     * @function  formatterEndDate   结束日期过滤
     * @param { Object } row        点击查看所在的行
     * @param { String } id         查看跳转的查询参数
     */
    formatterStartDate(row, column) {
      return row.startTime.substring(0, 10);
    },
    formatterEndDate(row, column) {
      return row.endTime.substring(0, 10);
    },
    /**
     * @description 页码变化监听函数
     */
    // handlePageChange(val) {
    //   this.page.pageNum = val;
    //   this.getNoticeList(this.queryData);
    // },
    // nextClick(nextPageNum){
    //   this.pageNum=nextPageNum
    //   this.HomeLists()
    // },
    // prevClick(prevPageNum){
    //     this.pageNum=prevPageNum
    //     this.HomeLists()
    // },
    // currentClick(currentPageNum){
    //     this.pageNum=currentPageNum
    //     this.HomeLists()
    // },
  },
  created() {
    // 页面未挂载前请求字典
    this.getDictionariesData();
  },
  mounted() {
    // 公告列表接口请求
    this.getNoticeList(this.queryData);
  },
};
</script>
<style lang="scss" scoped>
.announcementview {
  height: 100%;
  .el-card{
    height: 100%;
      /deep/ .el-card__header {
    border-bottom: 0;
    padding: 20px 20px 0px 20px;
  }
  /deep/.el-table .success-row {
    background: #FAFAFA;
  }
  .select_box{
    .select_box_input{
        flex: 1;
    /deep/.el-select{
      margin-right: 20px;
      margin-bottom: 20px;
    }
    /deep/.el-input__inner {
        border-radius: 2px;
        background: #f5f5f5;
    }
          // 选择框图标
    /deep/.el-icon-arrow-up:before {
        content: "\e790";
    }
      /deep/.el-range-input{
        background: #F5F5F5;
      }
      /deep/.el-range-editor--small.el-input__inner{
        width: 236px !important;
      }
    }
    .select_box_btn{
        width: 240px;
        text-align: right;
    }
  }
 /deep/.el-table {
   margin-top: 20px;
  }
  // 分页
  .pageschange{
    margin: 20px auto;
    text-align: center;
    }
  }
}
</style>
